import React from 'react';
import Logo from '../components/Logo';
import ConverterCard from '../components/ConverterCard';
import BuyMeCoffee from '../components/BuyMeCoffee';
import llamaImage from '../assets/images/llama-3.png';
import PhraseCarousel from '../components/PhraseCarousel';

const converters = [
  { from: 'PNG', to: 'JPEG' },
  { from: 'JPEG', to: 'WEBP' },
  { from: 'PNG', to: 'WEBP' },
  { from: 'WEBP', to: 'PNG' },
  { from: 'HEIC', to: 'JPEG' },
  { from: 'TIFF', to: 'JPEG' }  // Добавляем новый конвертер
];

const phrases = [
  "Online image converter",
  "Convert PNG to JPG online",
  "Convert image online",
  "High-quality image conversion",
  "Online photo converter",
  "Free photo converter",
  "Image converter online",
  "Best online image converter",
  "Image conversion tool"
];

function Home() {
  return (
    <div className="container mx-auto px-4">
    <a href="/" style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}> Home </a>
      <Logo />
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8 md:w-[80%] mx-auto">
        {converters.map((converter, index) => (
          <ConverterCard
            key={index}
            from={converter.from}
            to={converter.to}
          />
        ))}
      </div>
      <BuyMeCoffee />
      <img src={llamaImage} alt="llamaImage" className="w-[70%] md:w-[25%] mx-auto mb-8" />
      
      <div className="flex items-center justify-center bg-gray-100 mb-8">
        <PhraseCarousel phrases={phrases} direction="ltr" />
      </div>
      
    </div>
  );
}

export default Home;
